import { useState } from 'react'

import { usePSNavigate } from '../../hooks/usePSNavigate'
import { RecordFactory } from '../../models/RecordFactory'
import { NavigationBlockerPrompt } from '../NavigationBlockerPrompt'
import { PocketComponentProps, usePSComponent } from '../PocketComponent'
import Button from '../app/design/Button'
import { Chip } from '../common/fields/Chip'
import { SearchableSelect } from '../common/fields/SearchableSelect'
import { Select } from '../common/fields/Select'
import { WorkflowPage } from '../workflows/WorkflowPage'
import { gratuityOptions, gratuityPercentOptions } from './Options'

const render = ({ base }: PocketComponentProps<void>) => {
    const [user, setUser] = useState(base.me.clone())
    const navigate = usePSNavigate()

    const hasEdits =
        base.me.gratuity !== user.gratuity || base.me.requestGratuity !== user.requestGratuity

    const onSave = async () => {
        base.showProgressBar('Saving...')
        const result = await RecordFactory.getInstance().sendUser(user)
        base.hideProgressBar()

        if (!result.ok) {
            base.logAndDisplayError(result.error)
            return
        }

        navigate('/settings')
    }

    return (
        <WorkflowPage
            title="Gratuity"
            footerContent={
                <div className="flex w-full items-center justify-end gap-x-4">
                    <Button intent="primary" disabled={!hasEdits} onClick={onSave}>
                        Save
                    </Button>
                </div>
            }
        >
            <div className="mt-12 flex w-full flex-col items-center justify-start">
                <WorkflowPage.Card>
                    <WorkflowPage.IconSection title="Request gratuity" icon="settings.large">
                        <div className="flex flex-wrap gap-2">
                            {gratuityOptions.map((option) => (
                                <Chip
                                    key={`req-grat-option-${option.value}`}
                                    title={option.label}
                                    isSelected={user.requestGratuity === option.value}
                                    onClick={() =>
                                        setUser(user.clone({ request_gratuity: option.value }))
                                    }
                                    size="small"
                                />
                            ))}
                        </div>
                    </WorkflowPage.IconSection>

                    <WorkflowPage.IconSection title="Suggested gratuity" icon="dollar.large">
                        <SearchableSelect
                            size="medium"
                            className="border-gray-500"
                            items={gratuityPercentOptions.map((option) => ({
                                id: option.value,
                                title: option.label,
                            }))}
                            onSelectItem={(selection) =>
                                setUser(user.clone({ gratuity: selection?.id }))
                            }
                            selectedItemID={user.gratuity?.toString() ?? ''}
                            shouldPreserveLastSelection
                        />
                    </WorkflowPage.IconSection>
                </WorkflowPage.Card>
            </div>

            <NavigationBlockerPrompt when={hasEdits} />
        </WorkflowPage>
    )
}

export const SetupGratuityPage = usePSComponent(render)
